import { render, staticRenderFns } from "./skeletonBox.vue?vue&type=template&id=4befe5df&scoped=true&"
import script from "./skeletonBox.vue?vue&type=script&lang=js&"
export * from "./skeletonBox.vue?vue&type=script&lang=js&"
import style0 from "./skeletonBox.vue?vue&type=style&index=0&id=4befe5df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4befe5df",
  null
  
)

export default component.exports